import xssModule from 'xss'
import balanceHtml from './balanceHtml'

// xss is CommonJS: Node ESM detects only FilterXSS/filterXSS as named exports, so use the default (the whole
// module at runtime), which the typings declare as just the filter function.
const xss = xssModule as unknown as typeof import('xss')

const SAFE_HREF = /^(?:https?:|mailto:|tel:|\/(?![/\\&])|\?|#)/i
const SPAN_CLASSES = new Set(['text--featured'])

const filter = new xss.FilterXSS({
    whiteList: {
        b: [], strong: [], i: [], em: [], u: [], s: [], br: [], p: [],
        div: ['style'],
        span: ['style', 'class'],
        h2: [], h3: [], ul: [], ol: [], li: [],
        table: [], thead: [], tbody: [], tr: [],
        th: ['colspan', 'rowspan'],
        td: ['colspan', 'rowspan'],
        a: ['href', 'title', 'rel'],
    },
    css: {
        whiteList: {
            'font-size': /^\d{1,2}(\.\d+)?(px|em|rem|%)$/,
            'color': /^(#[0-9a-f]{3,8}|[a-z]+|rgba?\([\d\s.,%]+\))$/i,
            'text-align': /^(left|right|center|justify)$/,
        },
    },
    stripIgnoreTag: false,
    stripIgnoreTagBody: false,
    onTagAttr(tag, name, value) {
        if (tag === 'a' && name === 'href') {
            // Check the decoded value and emit that, never the raw one: the browser would decode `&#x09;` again.
            // Never fall through to xss's safeAttrValue, which rejects `?…` and then emits a bare `href`.
            const href = xss.friendlyAttrValue(value)
            return SAFE_HREF.test(href) ? `href="${xss.escapeAttrValue(href)}"` : ''
        }

        if (tag === 'span' && name === 'class') {
            const classes = value.split(/\s+/).filter(token => SPAN_CLASSES.has(token))
            return classes.length ? `class="${classes.join(' ')}"` : ''
        }
    },
})

/**
 * Sanitises backend or authored HTML for `v-html`: keeps the formatting tags messages and promotion copy use,
 * escapes every other tag so its text stays visible, and balances tags so SSR hydration is not broken.
 *
 * Pure string processing (no DOM), so server and client produce the identical string.
 */
export default function sanitizeHtml(html: string | null | undefined): string {
    if (!html) return ''

    return balanceHtml(filter.process(html))
}
